import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useCallback, useContext } from 'react';
import { Url } from '@wix/da-url';
import { pushGlobalConfirmationModal } from '../../Modals/redux/actionCreators';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
export function useRestrictedToCore(action, referer, params) {
    const { hasCoreMembership } = useContext(SessionContext);
    const dispatchPushGlobalConfirmationModal = useAction(pushGlobalConfirmationModal);
    const handleAction = useCallback((...args)=>{
        if (hasCoreMembership) {
            action(...args);
        } else {
            dispatchPushGlobalConfirmationModal(_object_spread_props(_object_spread({
                titleTransKey: 'coreUpsellModal.title',
                textTransKey: 'coreUpsellModal.text',
                confirmBtnLabelTransKey: 'common.upgradeCoreCTA',
                cancelBtnLabelTransKey: 'common.cancel',
                confirmBtnType: 'core',
                icon: /*#__PURE__*/ React.createElement("img", {
                    alt: "",
                    src: "https://st.deviantart.net/eclipse/illustrations/il2.15_core_ball_pixel.png",
                    width: "90px",
                    height: "88px"
                })
            }, params), {
                onConfirm: ()=>{
                    window.location.href = Url.coreMembershipLink(referer);
                }
            }));
        }
    }, [
        dispatchPushGlobalConfirmationModal,
        referer,
        action,
        hasCoreMembership,
        params
    ]);
    return handleAction;
}

//# sourceMappingURL=useRestrictedToCore.js.map